import classNames from "classnames";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEnvironment } from "../../customHooks/useEnvironment";
import { useLayout } from "../../customHooks/useLayout";
import { useAppSelector } from "../../redux/hooks";
import { OnboardingChecklist } from "./onboardingChecklist";

export const OnboardingPopup = () => {
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const { environment } = useEnvironment();

  const { onboardingCompletionStatus, profile } = useAppSelector((state) => {
    return state.auth;
  });

  const popupOpen = useAppSelector((state) => {
    return state.layout.onboardingPopupOpen;
  });

  const { setPopupOpen, closePopup, isWhitelistedPath } = useLayout();

  useEffect(() => {
    if (
      !isWhitelistedPath(location.pathname) &&
      profile?.type === "member" &&
      !onboardingCompletionStatus?.isAllComplete
    ) {
      setPopupOpen(true);
    } else if (
      isWhitelistedPath(location.pathname) &&
      profile?.type === "member" &&
      !onboardingCompletionStatus?.isAllComplete &&
      popupOpen
    ) {
      setPopupOpen(false);
    }
    // eslint-disable-next-line
  }, [location.pathname, profile, searchParams]);

  return (
    <>
      {/* Overlay  */}
      {popupOpen && (
        <div
          className={`absolute z-[997] inset-0 bg-black/50`}
          onClick={() => {
            closePopup();
          }}
        />
      )}

      {/* Content */}
      <div
        className={classNames(
          `
          absolute z-[997]
          left-0 right-0 md:top-auto
          md:bottom-10 md:right-24 md:left-auto
          w-full md:w-fit md:max-w-[590px]
          flex flex-col md:gap-6 items-end
          transition-all duration-500
        `,
          {
            "md:!gap-0 bottom-[90px]": !popupOpen && environment === "mobile",
            "md:!gap-0 bottom-[70px]": !popupOpen && environment !== "mobile",
            "top-0 md:!top-8 bottom-0": popupOpen,
          }
        )}
      >
        <div
          className={classNames(
            `flex-1 md:max-h-[669px] md:shadow-xl overflow-y-scroll`,
            {
              "!h-0 !w-0 !max-h-0 md:max-h-0 overflow-hidden": !popupOpen,
            },
            "md:rounded-lg transition-all duration-300"
          )}
        >
          <OnboardingChecklist />
        </div>

        <button
          type="button"
          className={`
            w-full md:w-fit text-left
            px-8 py-6 md:rounded-[56px]
            text-base lg:text-[20px] font-bold
            transition-all duration-500 mt-auto
            md:hover:scale-[0.98] hover:cursor-pointer
            ${
              popupOpen
                ? "text-pry-dark-green-100 bg-white border-t md:border-t-0"
                : "text-white bg-pry-dark-green-100 max-md:pt-3"
            }
            `}
          onClick={() => {
            if (popupOpen) {
              closePopup();
            } else {
              setPopupOpen(true);
            }
          }}
        >
          <p className="line-clamp-1">
            Onboarding Checklist |{" "}
            {onboardingCompletionStatus?.onboardingCompletionProgress}% complete
          </p>
        </button>
      </div>
    </>
  );
};
